import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';

class SaveTemplateAssignment {
	constructor(
		public readonly scope: TemplateAssignmentScope,
		// The type's numeric identifier: it travels in the URL, never in the body.
		public readonly documentTypeId: number,
		public readonly templateId: number,
	) {
		Object.freeze(this);
	}

	// `documentTypeId` is already in the URL: repeating it here would fail `forbidNonWhitelisted`.
	toJSON(): Record<string, unknown> {
		return {
			templateId: this.templateId,
		};
	}
}

export default SaveTemplateAssignment;
